







import { Vue, Component } from 'vue-property-decorator';
import * as config from './config';
import VoteList from './components/VoteList.vue';
import { appShare, wxShareInfo } from '@/common/ts/common';
import Org from './components/Org.vue';

@Component({
  name: 'Activities',
  components: {
    VoteList,
    Org,
  },
})
export default class Activities extends Vue {
  option = config.OPTHINES;
  created() {
    this.$addPv(382);
    appShare({
      title: '最美生态环保志愿者评选',
      url: window.location.href,
      subtitle: '最美生态环保志愿者评选',
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      classId: -1,
      id: -1,
      type: 3,
    });
    wxShareInfo({
      title: '最美生态环保志愿者评选',
      subtitle: '最美生态环保志愿者评选',
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    });
  }
}
